export const stakeholderCommunicationState = [
  'You are about to approach',
  'In Contact',
  'Close Deal',
]

export const stakeholderGroup = [
  'Internal',
  'External'
]